/**
 * @generated SignedSource<<6f1f825d225a7b55a8fcd277ef0f7431>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FeatureKey = "ADDITIONAL_LISTS" | "BIOMETRIC_LOCK" | "BUDGET" | "ESTATE_SEARCH" | "EXTENDED_ADDRESS_LOOKUP" | "FLOOD_MAP" | "HOME_FEED" | "HOME_OWNERSHIP" | "HOME_RECORDS" | "HOME_UPDATES" | "HOME_UPDATES_PUSH_ANNIVERSARY" | "HOME_UPDATES_PUSH_FLOOD" | "HOME_UPDATES_PUSH_HOME_VALUE" | "HOME_UPDATES_PUSH_PLANNING" | "HOME_UPDATES_PUSH_RATE_DECISION" | "HOME_UPDATES_PUSH_RENT_CHECK" | "HOME_UPDATES_PUSH_SOLD_NEAR_YOU" | "HOUSEHOLD_MONEY" | "JOURNEY_NUDGES" | "LISTING_PHOTO_IMPORT" | "LOCAL_KNOWLEDGE" | "NOISE_INSIGHT" | "PERSONA_JOURNEYS" | "REACHABLE_AREA_SCENE" | "REALTIME_PRESENCE" | "REAL_JOURNEY_TIMES" | "REMOTE_FETCH_IMPORT" | "VIEWINGS" | "VIEWING_NOTE_SUGGESTIONS" | "VOICE" | "%future added value";
export type OverrideState = "OFF" | "ON" | "%future added value";
export type vaultToggleMutationsSetFeatureOverrideMutation$variables = {
  key: FeatureKey;
  state: OverrideState;
  vaultId: any;
};
export type vaultToggleMutationsSetFeatureOverrideMutation$data = {
  readonly setFeatureOverride: {
    readonly flagKey: FeatureKey;
    readonly state: OverrideState;
    readonly vaultId: any;
  };
};
export type vaultToggleMutationsSetFeatureOverrideMutation = {
  response: vaultToggleMutationsSetFeatureOverrideMutation$data;
  variables: vaultToggleMutationsSetFeatureOverrideMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "state"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vaultId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "key"
      },
      {
        "kind": "Variable",
        "name": "state",
        "variableName": "state"
      },
      {
        "kind": "Variable",
        "name": "vaultId",
        "variableName": "vaultId"
      }
    ],
    "concreteType": "FeatureOverrideState",
    "kind": "LinkedField",
    "name": "setFeatureOverride",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "flagKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vaultId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "vaultToggleMutationsSetFeatureOverrideMutation",
    "selections": (v3/*: any*/),
    "type": "FeatureToggleMutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "vaultToggleMutationsSetFeatureOverrideMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "cc85c31eb5161e9e3aa99557542e1cef",
    "id": null,
    "metadata": {},
    "name": "vaultToggleMutationsSetFeatureOverrideMutation",
    "operationKind": "mutation",
    "text": "mutation vaultToggleMutationsSetFeatureOverrideMutation(\n  $key: FeatureKey!\n  $vaultId: UUID!\n  $state: OverrideState!\n) {\n  setFeatureOverride(key: $key, vaultId: $vaultId, state: $state) {\n    flagKey\n    vaultId\n    state\n  }\n}\n"
  }
};
})();

(node as any).hash = "c796aab5e4bf056565f98c38c07b2910";

export default node;
